import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { User } from 'src/types/user.types';
import { educationLevelsQueryOptions } from 'src/queries/education_levels';

export const useWarmEducationLevelsCache = (currentUser?: User): void => {
  const queryClient = useQueryClient();
  const lastWarmed = useRef<string | undefined>(undefined);

  useEffect(() => {
    const country = currentUser?.country;
    if (!country || country === lastWarmed.current) return;

    lastWarmed.current = country;
    void queryClient
      .prefetchQuery(educationLevelsQueryOptions(country))
      .catch(() => {
        // Best-effort warming only — a failed prefetch just means the pickers or the next identify
        // pass fetch it normally later.
      });
  }, [currentUser?.country, queryClient]);
};
